export default (id: string): boolean => id.includes('_');
